import {
  Component,
  NgZone,
  Input,
  SimpleChanges,
  Output,
  EventEmitter,
  Inject
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import {
  RealtorPortalService
} from '../../../services/network/realtor-portal.service';



@Component({
  templateUrl: './extended-area.component.html',
  styleUrls: ['./extended-area.component.css'],
})
export class ExtendedAreaDialogComponent {
  planDetail: any;
    Title: string;
  ExtendedLanguage: string;
  DocumentURL: string;
  DocumentName: string;


  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private customerPortalService: RealtorPortalService) {
    const state: string = data;

    this.DocumentURL = "https://common.oneguardhomewarranty.com/RealEstate/Content/images/SampleContracts/ExtendedArea/" + state.toLowerCase() + ".pdf";
    this.DocumentName = "SampleContract.pdf";

    if (state == 'AZ') {
      this.Title = "Arizona Disclaimer";
      this.ExtendedLanguage = "Noted services are available in Phoenix and Tucson metropolitan areas. Click below to see our extended area sample contract.For more specifics, please reach out to our sales team at 888-896-0014.";
      
    }
    else if (state == 'TX') {
      this.Title = "Texas Disclaimer";
      this.ExtendedLanguage = "Noted services are available in Dallas/Fort Worth, Houston, Austin, and San Antonio metropolitan areas.Click below to see our extended area sample contract. For more specifics, please reach out to our sales team at 888-896-0014.";
    }
    else {
      this.Title = "No Contract Avaliable";
      this.ExtendedLanguage = "There are currently no sample contracts avaliable for your selected state.";
    }

  }

}
